import {
	FIRST_LOGIN,
	STORAGE_KEY_AVAILABLE_REVOLVING_APPLICATION_VIEWED,
	STORAGE_KEY_BENEFIT_BOX,
	STORAGE_KEY_PROCESSING_REVOLVING_APPLICATION_VIEWED,
} from 'constants/queryAndStorageKeys';

import { ApolloLink } from '@apollo/client';
import { TOKEN_STORAGE_KEY } from 'modules/auth/constants';
import store from 'store2';

export type TokenData = {
	accessToken: string;
	expiresIn: number;
	fullAccess?: boolean;
	retrievedAt: number;
};

export function getTokenData(): TokenData | undefined {
	return store.session.get(TOKEN_STORAGE_KEY);
}

function setAccessTokenRetrievedNow(tokenData: TokenData) {
	// eslint-disable-next-line no-param-reassign
	if (tokenData) tokenData.retrievedAt = Date.now();
	return tokenData;
}

export function setAccessTokenData(tokenData: TokenData): void {
	store.session.set(TOKEN_STORAGE_KEY, setAccessTokenRetrievedNow(tokenData));
}

export function slideAccessTokenExpiration(): TokenData {
	const updatedTokenData = setAccessTokenRetrievedNow(store.session.get(TOKEN_STORAGE_KEY));
	store.session.set(TOKEN_STORAGE_KEY, updatedTokenData);
	return updatedTokenData;
}

export function clearUserSessionData(): void {
	store.session.remove(TOKEN_STORAGE_KEY);
	store.session.remove(STORAGE_KEY_AVAILABLE_REVOLVING_APPLICATION_VIEWED);
	store.session.remove(STORAGE_KEY_PROCESSING_REVOLVING_APPLICATION_VIEWED);
	store.session.remove(FIRST_LOGIN);
	store.session.remove(STORAGE_KEY_BENEFIT_BOX);
}

export function isValidAccessToken(tokenData: TokenData): boolean {
	return tokenData && Date.now() < tokenData.retrievedAt + tokenData.expiresIn * 1000;
}

export function getValidAccessToken(): string | undefined {
	const tokenData = getTokenData();
	if (tokenData && !isValidAccessToken(tokenData)) {
		clearUserSessionData();
		return undefined;
	}
	return (tokenData && tokenData.accessToken) || undefined;
}

export const getAuthorizationApolloLink = (
	defaultAccessToken?: TokenData['accessToken']
): ApolloLink =>
	new ApolloLink((operation, forward) => {
		const accessToken = defaultAccessToken || getValidAccessToken();
		if (accessToken) {
			operation.setContext({
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
			});
		}
		return forward(operation);
	});
